/* World Spice 2026 homepage — shared behavior for the ws-* sections. */
(function () {
  'use strict';

  // The script tag is emitted by several sections; only initialize once.
  if (window.__wsHomeInit) return;
  window.__wsHomeInit = true;

  /* --- Tin label auto-fit: shrink each label line until it fits --- */
  function fitWords(root) {
    (root || document).querySelectorAll('.ws-home .prod__word, .ws-home .mini__word').forEach(function (w) {
      var base = parseFloat(getComputedStyle(w).fontSize);
      w.querySelectorAll('span').forEach(function (s) {
        s.style.fontSize = '';
        var avail = w.clientWidth - 2;
        if (!avail || !s.scrollWidth) return;
        var size = base;
        while (s.scrollWidth > avail && size > 13) {
          size -= 1;
          s.style.fontSize = size + 'px';
        }
      });
    });
  }
  // Exposed so sections that inject cards after load (ws-recently-viewed) can
  // re-fit the labels they just added.
  window.wsFitWords = fitWords;
  window.addEventListener('load', function () { fitWords(); });
  window.addEventListener('resize', function () { fitWords(); });
  if (document.fonts) document.fonts.ready.then(function () { fitWords(); });
  document.addEventListener('shopify:section:load', function (e) { fitWords(e.target); });

  /* --- Staff picks: thumbnail switches stage tin + detail panel --- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.ws-home .pthumb');
    if (!thumb) return;
    var section = thumb.closest('[data-ws-picks]');
    if (!section) return;
    var i = thumb.getAttribute('data-pick');
    section.querySelectorAll('.pthumb').forEach(function (t) {
      t.classList.toggle('is-on', t === thumb);
    });
    section.querySelectorAll('.pick').forEach(function (p) {
      p.classList.toggle('is-on', p.getAttribute('data-pick') === i);
    });
    fitWords(section);
  });

  /* --- Add to cart the Sleek-theme way: request the drawer section's
         updated HTML with the add, publish cartUpdate so the drawer
         re-renders, then open it. Falls back to cart:refresh. --- */
  function addToCart(variantId, quantity) {
    var drawer = document.querySelector('cart-drawer');
    var sectionId = null;
    try {
      if (window.FoxTheme && drawer) sectionId = FoxTheme.utils.getSectionId(drawer);
    } catch (err) { sectionId = null; }
    var body = { items: [{ id: variantId, quantity: quantity }] };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (parsed) {
      if (window.FoxTheme && sectionId && parsed.sections) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cartJson) {
          cartJson.sections = parsed.sections;
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
          if (drawer && drawer.show) drawer.show();
        });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    });
  }

  /* --- Variant chips / selects / quantity inside a pick's buy box --- */
  function currentVariant(buy) {
    var variants;
    try {
      variants = JSON.parse(buy.querySelector('[data-ws-variants]').textContent);
    } catch (err) {
      return null;
    }
    var chosen = [];
    buy.querySelectorAll('[data-ws-option]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-ws-option'), 10);
      if (group.tagName === 'SELECT') {
        chosen[idx] = group.value;
      } else {
        var on = group.querySelector('.opt.is-on');
        chosen[idx] = on ? on.getAttribute('data-value') : null;
      }
    });
    return variants.find(function (v) {
      return v.options.every(function (opt, idx) {
        return chosen[idx] === null || chosen[idx] === undefined || opt === chosen[idx];
      });
    }) || null;
  }

  function refreshBuy(buy) {
    var v = currentVariant(buy);
    var priceEl = buy.closest('.pick') && buy.closest('.pick').querySelector('.pdetail__price');
    var btn = buy.querySelector('.addcart');
    if (!btn) return;
    if (v) {
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold-out');
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
    } else {
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-label-unavailable');
    }
  }

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.ws-home .optrow .opt');
    if (opt) {
      var group = opt.closest('[data-ws-option]');
      group.querySelectorAll('.opt').forEach(function (x) {
        x.classList.toggle('is-on', x === opt);
      });
      refreshBuy(opt.closest('[data-ws-buy]'));
      return;
    }
    var qbtn = e.target.closest('.ws-home .qty button');
    if (qbtn) {
      var span = qbtn.parentElement.querySelector('span');
      var val = parseInt(span.textContent, 10) || 1;
      span.textContent = Math.max(1, val + (qbtn.hasAttribute('data-up') ? 1 : -1));
      return;
    }
    var quickAdd = e.target.closest('.ws-home [data-ws-add-variant]');
    if (quickAdd) {
      var vid = parseInt(quickAdd.getAttribute('data-ws-add-variant'), 10);
      if (!vid) return;
      var original = quickAdd.innerHTML;
      quickAdd.disabled = true;
      addToCart(vid, 1).then(function () {
        quickAdd.innerHTML = '<span style="width:100%;text-align:center">' + quickAdd.getAttribute('data-label-added') + '</span>';
        setTimeout(function () {
          quickAdd.disabled = false;
          quickAdd.innerHTML = original;
        }, 2000);
      }).catch(function () {
        quickAdd.disabled = false;
        quickAdd.innerHTML = original;
      });
      return;
    }
    var add = e.target.closest('.ws-home .addcart[data-label-add]');
    if (add) {
      var buy = add.closest('[data-ws-buy]');
      var variant = currentVariant(buy);
      if (!variant || !variant.available) return;
      var qty = parseInt(buy.querySelector('.qty span').textContent, 10) || 1;
      add.disabled = true;
      addToCart(variant.id, qty).then(function () {
        add.textContent = add.getAttribute('data-label-added');
        setTimeout(function () {
          add.disabled = false;
          add.textContent = add.getAttribute('data-label-add');
        }, 2000);
      }).catch(function () {
        add.disabled = false;
        add.textContent = add.getAttribute('data-label-add');
      });
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.ws-home [data-ws-option]');
    if (sel && sel.tagName === 'SELECT') refreshBuy(sel.closest('[data-ws-buy]'));
  });

  document.querySelectorAll('.ws-home [data-ws-buy]').forEach(refreshBuy);

  /* --- Newsletter signup modal (snippets/ws-newsletter-modal.liquid) -------
     Rendered once in layout/theme.liquid. Anything carrying data-ws-newsletter
     opens it: a WS content card, a nav link, a link typed into a rich-text
     block. Submitting posts Shopify's customer form in the background, so the
     shopper keeps their scroll position and sees the confirmation in place.
     With JS off the form still posts normally and reloads — same signup, worse
     experience. ------------------------------------------------------------ */
  function nlModal() { return document.getElementById('ws-newsletter-modal'); }

  function nlOpen() {
    var d = nlModal();
    if (!d) return;
    // Reset to the form panel so a second open after a signup isn't stuck on
    // the thank-you.
    nlPanel('form');
    var err = d.querySelector('[data-ws-nl-error]');
    if (err) err.hidden = true;
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
    var input = d.querySelector('.ws-nl__input');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function nlClose() {
    var d = nlModal();
    if (!d) return;
    if (typeof d.close === 'function') d.close();
    else d.removeAttribute('open');
  }

  function nlPanel(which) {
    var d = nlModal();
    if (!d) return;
    d.querySelectorAll('[data-ws-nl-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-ws-nl-panel') !== which;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ws-newsletter-close]')) {
      e.preventDefault();
      nlClose();
      return;
    }
    var trigger = e.target.closest('[data-ws-newsletter]');
    if (trigger) {
      e.preventDefault();
      nlOpen();
      return;
    }
    // Click on the backdrop (the dialog element itself, outside the box).
    var d = nlModal();
    if (d && d.open && e.target === d) nlClose();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'ws-newsletter-form') return;
    e.preventDefault();

    var d = nlModal();
    var submit = form.querySelector('.ws-nl__submit');
    var errEl = d && d.querySelector('[data-ws-nl-error]');
    var label = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = 'Signing you up…'; }
    if (errEl) errEl.hidden = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' }
    })
      .then(function (res) {
        return res.text().then(function (html) {
          return { url: res.url || '', html: html, ok: res.ok };
        });
      })
      .then(function (r) {
        // Shopify bounces back to the page with customer_posted=true on a
        // clean signup. If that param is missing we fall back to looking for
        // the error marker the snippet renders inside form.errors.
        var posted = r.url.indexOf('customer_posted=true') > -1;
        var failed = r.html.indexOf('data-ws-nl-server-error') > -1;
        if (posted || (r.ok && !failed)) {
          nlPanel('done');
          return;
        }
        var msg = '';
        try {
          var doc = new DOMParser().parseFromString(r.html, 'text/html');
          var marker = doc.querySelector('[data-ws-nl-server-error]');
          if (marker) msg = marker.textContent.trim();
        } catch (err) { /* fall through to the generic message */ }
        if (errEl) {
          errEl.textContent = msg || 'That email did not go through. Try again?';
          errEl.hidden = false;
        }
      })
      .catch(function () {
        if (errEl) {
          errEl.textContent = 'Something went wrong. Try again?';
          errEl.hidden = false;
        }
      })
      .then(function () {
        if (submit) { submit.disabled = false; submit.textContent = label; }
      });
  });

  /* --- Sticky CTA tab (snippets/ws-sticky-cta.liquid) ----------------------
     The tab itself carries data-ws-newsletter, so the handler above opens the
     popup. All that is left is the dismiss: hide it for the rest of the
     session. The markup ships hidden so a shopper who already closed it never
     sees it flash on the next page. --------------------------------------- */
  var STICKY_KEY = 'wsStickyCtaDismissed';

  function stickyStore(write) {
    try {
      if (write) { sessionStorage.setItem(STICKY_KEY, '1'); return true; }
      return sessionStorage.getItem(STICKY_KEY) === '1';
    } catch (err) {
      // Private windows and blocked site data throw; show the tab anyway.
      return false;
    }
  }

  function stickyInit() {
    var el = document.querySelector('[data-ws-sticky]');
    if (el && !stickyStore(false)) el.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', stickyInit);
  } else {
    stickyInit();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-ws-sticky-close]')) return;
    e.preventDefault();
    stickyStore(true);
    var el = document.querySelector('[data-ws-sticky]');
    if (el) el.hidden = true;
  });
})();
